import React, { useCallback, useMemo, useState } from "react";
import { CiSettings } from "react-icons/ci";
import DataTable from "../components/DataTable";
import Layout from "../components/Layout";
import Modal from "../components/Modal";
import ParameterButtons from "../components/ParameterButtons";
import { grids } from "../constants/grids"; // Import centralisé des grids
import { useLazyGetFieldsByFormQuery } from "../redux/formService";
import {
  useLazyGetParamsQuery,
  usePostParamMutation,
} from "../redux/paramService";
import { filterDataByDate } from "../utils";

const GestionEvenements = () => {
  const [showForm, setShowForm] = useState(false);
  const [filter, setFilter] = useState();
  const [selectedParams, setSelectedParams] = useState();
  const [showTable, setShowTable] = useState(false);
  const [selected, setSelected] = useState();
  const [selectedGrid, setSelectedGrid] = useState();
  const [fields, setFields] = useState();

  const [getFields, { data: fieldsData, isLoading: isFieldsLoading }] =
    useLazyGetFieldsByFormQuery();
  const [getParams, { data: paramsData, isLoading: isParamsLoading }] =
    useLazyGetParamsQuery();
  const [postParams] = usePostParamMutation();

  const handleShowModal = useCallback((props) => {
    setSelected(props?.attributes);
    localStorage.setItem("evenement", JSON.stringify(props));
    setShowForm(true);
  }, []);

  const selectParameter = async (e) => {
    setSelectedParams(e);
    setShowTable(false);

    let endpoint = grids[e]?.endpoint;
    let grid = grids[e]?.grid;

    if (!endpoint || !grid) return;

    await getFields(grids[e]?.formId);
    setFields(fieldsData?.data);

    setSelectedGrid(grid);

    setTimeout(() => {
      setShowTable(true);
    }, 0);
  };

  const sendData = (data) => {
    const endpointMap = {
      typeEvenement: "types-evenements",
      tarification: "tarifications",
      facturation: "facturations",
    };
    data.endpoint = endpointMap[selectedParams];
    postParams(data).then(() => {
      setShowForm(false);
      getParams({ endpoint: data.endpoint, page: 1, size: 20 });
    });
  };

  const filteredData = useMemo(
    () => filterDataByDate(paramsData, filter),
    [paramsData, filter]
  );

  return (
    <Layout title="Gestion des événements">
      <div className="w-full flex flex-col items-center">
        {!isFieldsLoading && (
          <Modal
            showForm={showForm}
            send={sendData}
            setShowForm={setShowForm}
            fields={fields}
            selectedData={selected}
          />
        )}
        <ParameterButtons
          selectParameter={selectParameter}
          parameters={[
            { label: "Type d'événement", value: "typeEvenement" },
            { label: "Tarification", value: "tarification" },
            { label: "Facturation", value: "facturation" },
          ]}
        />
        <div className="flex w-full space-x-4 justify-center items-center my-4">
          <button
            onClick={() => {
              setShowForm(!showForm);
              setSelected();
            }}
            className="text-white w-32 space-x-2 text-3xl flex bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            type="button">
            <CiSettings />
            <p className="text-base">Ajouter</p>
          </button>
        </div>
        {isParamsLoading ? (
          <p>Chargement des données...</p>
        ) : (
          showTable && (
            <DataTable
              data={filteredData || paramsData?.data}
              grid={selectedGrid}
              handleShowModal={handleShowModal}
            />
          )
        )}
      </div>
    </Layout>
  );
};

export default GestionEvenements;
